module.exports = __webpack_public_path__ + "static/logo-7ada2eaa497fc311fed7bb7a68cec34b.png";